export const assignmentMarks = () => {
    return [
        {label: "Grades", value: "Grades"},
        {label: "Numbers", value: "Numbers"},
        {label: "No Marks", value: "No Marks"},
        {label: "Decide later", value: "Decide later"},
    ]
}
export const assignTo = () => {
    return [
        {label: "All", value: "All"},
        {label: "Non Attendees", value: "Non Attendees"},
        {label: "Avg Performers", value: "Select"},
        {label: "Decide later", value: "Decide later"},
    ]
}
